module.exports = __webpack_public_path__ + "img/2_171.779f85a6.png";